import { flow, applySnapshot, getEnv } from 'mobx-state-tree'
import { ROLES } from 'constants/account.roles'

export const extendMember = (Model, options) => {
  const { type } = {
    ...options,
  }

  if (type == null) {
    throw Error('#extendMember helper (store), user flag should be defined')
  }

  const user = type

  return Model.actions((self) => {
    const {
      services: { memberService },
    } = getEnv(self)

    return {
      update: flow(function* ({ email, ...form }) {
        const data = yield memberService.updateProfile(form)
        // profile update triggers wallet
        applySnapshot(self, { ...data, wallet: self.wallet })
      }),

      changePassword: flow(function* (oldPassword, newPassword) {
        yield memberService.changePassword(oldPassword, newPassword)
      }),

      deleteProfile: flow(function* () {
        yield memberService.deleteProfile()
      }),
    }
  }).views((self) => ({
    hasRole(role) {
      return self.role === role
    },

    get isAdmin() {
      return self.role === ROLES.ADMIN
    },

    get isBeneficiary() {
      return user === ROLES.BENEFICIARY
    },

    get isSponsor() {
      return user === ROLES.SPONSOR
    },

    get isUser() {
      return !!user
    },
  }))
}
